import { UnassignedTooltipVM } from './unassignedTooltip';

/**
 * 未割当ピンのホバー内容を DOM で組む。
 *
 * Why 素の DOM: 未割当ピンは leaflet の `bindTooltip` で描く
 * (logposeTech/log_web_issues#321)。`bindTooltip` は HTML 文字列か DOM しか受けず、
 * MUI の `Box`/`sx` は使えない。
 *
 * Why not HTML 文字列: 見出しの地点名も荷主名も取り込んだ実データで、山括弧を含む
 * 表記が実際にありうる。テンプレート文字列で組むとエスケープが 1 箇所抜けただけで
 * スクリプトが動く。`textContent` に入れる限りその穴が生まれない。
 *
 * 見た目のクラス名は styles/globals.css が持つ（MUI の sx で当てていた寸法と同値）。
 */
export function buildUnassignedTooltipNode(vm: UnassignedTooltipVM): HTMLElement {
  const root = document.createElement('div');
  root.className = 'unassigned-tooltip';

  const title = document.createElement('div');
  title.className = 'unassigned-tooltip__title';
  title.textContent = vm.title;
  root.appendChild(title);

  vm.rows.forEach(({ label, value }) => {
    const row = document.createElement('div');
    row.className = 'unassigned-tooltip__row';

    const labelEl = document.createElement('span');
    labelEl.className = 'unassigned-tooltip__label';
    labelEl.textContent = label;
    row.appendChild(labelEl);

    const valueEl = document.createElement('span');
    valueEl.className = 'unassigned-tooltip__value';
    valueEl.textContent = value;
    row.appendChild(valueEl);

    root.appendChild(row);
  });

  return root;
}
